import Header from "./components/Header";
import Meme from "./components/Meme";
import Footer from "./components/Footer";

export default function App() {
  return (
    <div className="app">
      <Header />
      <Meme />
      <Footer />
    </div>
  );
}
